module.exports = __webpack_public_path__ + "protractor.3yM6w0qV.png";